import React, { useState } from 'react';
import { LABEL, PRODUCT_TABLE, TEXT } from '@moxie/constants';
import { Table } from '@shared-components/elements';
import { IInstitutionProducts } from '@shared-components/models';
import { Tag, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { instituteServices } from '@lyra/services.api';
import Text from 'antd/lib/typography/Text';
import { capitalizeFirstLetter } from 'libs/shared/src/functions';

const InstitutionDetailProducts: React.FC<any> = ({ id }: { id: any }) => {
  const [filter] = useState({});

  const getProductData = async (params: string) => {
    return instituteServices.apiGetInstitutionProducts(id, params);
  };

  const columns: ColumnsType<IInstitutionProducts> = [
    {
      title: LABEL.NAME,
      width: 500,
      dataIndex: 'name',
      sorter: () => 0,
      render(data: any) {
        return data && data?.length > 50 ? (
          <Tooltip title={data} placement="top">
            <Text
              className="text-primary-color product-ellipsis"
              ellipsis={true}
            >
              {capitalizeFirstLetter(data)}
            </Text>
          </Tooltip>
        ) : (
          <Text className="text-primary-color">
            {capitalizeFirstLetter(data)}
          </Text>
        );
      },
    },
    {
      title: TEXT.BRANCH,
      dataIndex: 'institutionBranches',
      width: 500,
      render(data: any) {
        return data?.map((item: any) => (
          <Tag key={item.id}>{item?.branch?.name}</Tag>
        ));
      },
    },
    {
      title: PRODUCT_TABLE.DEGREE_LEVEL,
      dataIndex: 'level',
      width: 250,
    },
  ];

  return (
    <div className="margin-top-1">
      <Table columns={columns} action={getProductData} filter={filter} />
    </div>
  );
};
export default InstitutionDetailProducts;
